import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import { flatpickrConfig } from '../../../config';
import vSelect from 'vue-select';

delete flatpickrConfig.mode

export default {
    name: 'grDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            grs: [],
            departments: [],
            search: {
                department: '',
                title: '',
                dateOfIssue:'',
                grUniqueCode: '',
            },
            flatpickrConfig,
            departmentCustomFieldId: 72,
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            vm.getCustomFields([
                vm.departmentCustomFieldId,
            ]).then(function (res) {
                vm.departments = res.data[vm.departmentCustomFieldId];
            }).catch(function (err) {
                console.log(err);
                return err
            });

            return vm.getGRs()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.grs = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },

        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getGRs()
                .then(function (res) {
                    vm.grs = vm.grs.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            
            vm.getGRs()
                .then(function (res) {
                    vm.grs = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getCustomFields(ids) {
            let vm = this;

            let customFieldsURL = 'o/customFields?';

            for (let [index, id] of ids.entries()) {
                if (index == 0) {
                    customFieldsURL += `id=${id}`
                } else {
                    customFieldsURL += `&id=${id}`
                }
            }
            return axiosCommon.get(customFieldsURL)
        },
        getGRs() {
            let vm = this;
            return axiosCommon.get(`o/grs?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&dateOfIssue=${vm.search.dateOfIssue}&title=${vm.search.title}&grUniqueCode=${vm.search.grUniqueCode}&department=${vm.search.department?vm.search.department:''}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/gr-dashboard/gr-dashboard.js